import LDClient from 'launchdarkly-js-client-sdk';

import { LAUNCH_DARKLY_CLIENT_ID } from '../constants/featureFlags';

export function initialize(clientId, countryCode) {
  return new Promise((resolve, reject) => {
    const client = LDClient.initialize(LAUNCH_DARKLY_CLIENT_ID, {
      key: clientId,
      country: countryCode
    });

    client.on('ready', () => {
      const flags = Object.entries(client.allFlags()).reduce(
        ({ keys, values }, [key, value]) => ({
            keys: keys.concat(key),
            values: values.concat({ source: 'launch-darkly', value }),
          }),
        { keys: [], values: [] }
      );

      resolve(flags);
    });
    client.on('failed', reject);
    client.on('error', reject);
  });
}
